import React from 'react';

/**
 * Returns true when a click on a link should be hijacked for SPA navigation.
 * Lets modifier-clicks and non-self targets fall through to native browser
 * behavior (new tab/window, download, etc.) so "open in new tab" works for free.
 */
export function shouldInterceptLinkClick(event: React.MouseEvent, target?: string): boolean {
    return (
        event.button === 0 &&
        (!target || target === '_self') &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey &&
        !event.defaultPrevented
    );
}
